(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Cache DOM elements
  const elements = {
    menuToggle: document.querySelector('.custom-header__menu-toggle'),
    burgerIcon: document.querySelector('.custom-header__burger-icon'),
    closeIcon: document.querySelector('.custom-header__close-icon'),
    mobileNav: document.querySelector('.custom-header__mobile-nav'),
    overlay: document.querySelector('.custom-header__overlay'),
    header: document.querySelector('.custom-header'),
    primaryMenu: document.querySelector('.custom-header__primary-menu'),
    megaMenuTriggers: document.querySelectorAll('[data-megamenu-trigger]'),
    megaMenuPanels: document.querySelectorAll('[data-mega-menu-panel]')
  };
  
  const root = document.documentElement;
  let activeMegaMenuPanel = null;
  let hideTimeout = null;
  const ANIMATION_DURATION = 300;

  // Set header height as CSS variable
  function setHeaderHeight() {
    if (elements.header) {
      root.style.setProperty('--custom-header-height', `${elements.header.offsetHeight}px`);
    }
  }
  
  // Mobile menu functions
  function openMobileMenu() {
    elements.mobileNav.dataset.state = 'open';
    elements.overlay.dataset.state = 'open';
    
    if (elements.menuToggle) {
      elements.menuToggle.setAttribute('aria-expanded', 'true');
      elements.menuToggle.setAttribute('aria-label', 'Close menu');
    }
    
    if (elements.burgerIcon) elements.burgerIcon.style.display = 'none';
    if (elements.closeIcon) elements.closeIcon.style.display = 'block';
    
    document.body.style.overflow = 'hidden';
  }

  function closeMobileMenu() {
    elements.mobileNav.dataset.state = 'closed';
    elements.overlay.dataset.state = 'closed';
    
    if (elements.menuToggle) {
      elements.menuToggle.setAttribute('aria-expanded', 'false');
      elements.menuToggle.setAttribute('aria-label', 'Open menu');
    }
    
    if (elements.burgerIcon) elements.burgerIcon.style.display = 'block';
    if (elements.closeIcon) elements.closeIcon.style.display = 'none';
    
    document.body.style.overflow = '';
  }

  // Mega menu functions
  function showMegaMenu(panelId) {
    if (hideTimeout) {
      clearTimeout(hideTimeout);
      hideTimeout = null;
    }
    
    const panel = document.getElementById(panelId);
    if (!panel || panel === activeMegaMenuPanel) return;
    
    // If there's an active panel, animate it out first
    if (activeMegaMenuPanel) {
      // Start hiding the current panel with animation
      activeMegaMenuPanel.classList.remove('mega-menu-panel--visible');
      
      // Wait for animation to complete before showing the new panel
      setTimeout(() => {
        activeMegaMenuPanel.style.display = 'none';
        
        // Now show the new panel
        panel.style.display = 'block';
        panel.offsetHeight; // Force reflow
        panel.classList.add('mega-menu-panel--visible');
        activeMegaMenuPanel = panel;
      }, 300); // Match the CSS transition duration
    } else {
      // No active panel, just show this one
      panel.style.display = 'block';
      panel.offsetHeight; // Force reflow
      panel.classList.add('mega-menu-panel--visible');
      activeMegaMenuPanel = panel;
    }
    
    // Clean up any previous handlers
    if (panel._hideTransitionHandler) {
      panel.removeEventListener('transitionend', panel._hideTransitionHandler);
      delete panel._hideTransitionHandler;
    }
  }

  function hideMegaMenu(panel, immediate = false) {
    if (!panel) return;
    
    if (immediate) {
      panel.classList.remove('mega-menu-panel--visible');
      panel.style.display = 'none';
      
      if (activeMegaMenuPanel === panel) {
        activeMegaMenuPanel = null;
      }
      
      if (panel._hideTransitionHandler) {
        panel.removeEventListener('transitionend', panel._hideTransitionHandler);
        delete panel._hideTransitionHandler;
      }
    } else {
      if (hideTimeout) clearTimeout(hideTimeout);
      
      hideTimeout = setTimeout(() => {
        // Start the fade-out animation
        panel.classList.remove('mega-menu-panel--visible');
        
        // Listen for the end of animation to hide the element
        panel._hideTransitionHandler = function(event) {
          if ((event.propertyName === 'opacity' || event.propertyName === 'transform') && 
              !panel.classList.contains('mega-menu-panel--visible')) {
            panel.style.display = 'none';
            panel.removeEventListener('transitionend', panel._hideTransitionHandler);
            
            if (activeMegaMenuPanel === panel) {
              activeMegaMenuPanel = null;
            }
            
            delete panel._hideTransitionHandler;
          }
        };
        
        panel.addEventListener('transitionend', panel._hideTransitionHandler);
        
        // Safety fallback (with increased timeout to ensure animation completes)
        setTimeout(() => {
          if (!panel.classList.contains('mega-menu-panel--visible') && 
              panel.style.display !== 'none' && 
              panel._hideTransitionHandler) {
            panel.style.display = 'none';
            panel.removeEventListener('transitionend', panel._hideTransitionHandler);
            
            if (activeMegaMenuPanel === panel) {
              activeMegaMenuPanel = null;
            }
            
            delete panel._hideTransitionHandler;
          }
        }, ANIMATION_DURATION + 50);
        
        hideTimeout = null;
      }, 200); // Delay before hiding
    }
  }

  function hideAllMegaMenus(immediate = true) {
    elements.megaMenuPanels.forEach(panel => {
      if (panel.classList.contains('mega-menu-panel--visible') || 
          panel.style.display !== 'none') {
        hideMegaMenu(panel, immediate);
      }
    });
  }

  // Dynamic count updates
  function updateCartCount() {
    const cartCountElement = document.querySelector('.custom-header__cart-count');
    if (!cartCountElement) return;
    
    fetch('{{ routes.cart_url }}.js')
      .then(response => response.json())
      .then(cart => {
        if (cart && typeof cart.item_count !== 'undefined') {
          cartCountElement.textContent = cart.item_count;
        }
      })
      .catch(error => console.error('Error fetching cart:', error));
  }

  function updateQuotesCount() {
    const headerQuotesElement = document.querySelector('.custom-header__right .custom-header__quotes-count');
    const mobileQuotesElement = document.querySelector('.custom-header__mobile-menu-secondary .custom-header__quotes-count');
    
    let cookieCount = 0;
    if (typeof getCookieList === 'function') {
      cookieCount = getCookieList('sticks--request__quote').length;
    } else {
      console.warn('getCookieList function not defined. Quotes count may not be accurate.');
    }
    
    const displayCount = cookieCount > 9 ? "9+" : cookieCount.toString();
    
    if (headerQuotesElement) headerQuotesElement.innerHTML = displayCount;
    if (mobileQuotesElement) mobileQuotesElement.innerHTML = displayCount;
  }

  // Nav hover effects
  function setupNavHoverEffects() {
    // For primary menu
    const primaryMenuItems = document.querySelectorAll('.custom-header__primary-menu li a');
    const primaryMenuParent = document.querySelector('.custom-header__primary-menu');
    
    if (primaryMenuParent && primaryMenuItems.length) {
      // Add hover effects for mega menu items
      primaryMenuItems.forEach(item => {
        item.addEventListener('mouseenter', () => {
          primaryMenuItems.forEach(otherItem => {
            if (otherItem !== item) {
              otherItem.style.opacity = '0.5';
            } else {
              otherItem.style.opacity = '1';
            }
          });
        });
      });
      
      // Reset when leaving the menu area
      primaryMenuParent.addEventListener('mouseleave', () => {
        primaryMenuItems.forEach(item => {
          item.style.opacity = '1';
        });
      });
    }
    
    // For secondary menu
    const secondaryMenuItems = document.querySelectorAll('.custom-header__secondary-menu li a');
    const secondaryMenuParent = document.querySelector('.custom-header__secondary-menu');
    
    if (secondaryMenuParent && secondaryMenuItems.length) {
      // Add hover effects for secondary menu items
      secondaryMenuItems.forEach(item => {
        item.addEventListener('mouseenter', () => {
          secondaryMenuItems.forEach(otherItem => {
            if (otherItem !== item) {
              otherItem.style.opacity = '0.5';
            } else {
              otherItem.style.opacity = '1';
            }
          });
        });
      });
      
      // Reset when leaving the menu area
      secondaryMenuParent.addEventListener('mouseleave', () => {
        secondaryMenuItems.forEach(item => {
          item.style.opacity = '1';
        });
      });
    }
    
    // For mega menu items
    document.querySelectorAll('.custom-header__mega-menu-panel').forEach(megaMenu => {
      const megaMenuLinks = megaMenu.querySelectorAll('.mega-menu__link');
      
      if (megaMenuLinks.length) {
        megaMenuLinks.forEach(link => {
          link.addEventListener('mouseenter', () => {
            megaMenuLinks.forEach(otherLink => {
              if (otherLink !== link) {
                otherLink.style.opacity = '0.5';
              } else {
                otherLink.style.opacity = '1';
              }
            });
          });
        });
        
        // Reset when leaving the mega menu
        const megaMenuList = megaMenu.querySelector('.mega-menu__list');
        if (megaMenuList) {
          megaMenuList.addEventListener('mouseleave', () => {
            megaMenuLinks.forEach(link => {
              link.style.opacity = '1';
            });
          });
        }
      }
    });
  }

  // Mobile menu functions
  function setupMobileMenu() {
    const mobileMenuItems = document.querySelectorAll('.mobile-menu-item');
    
    mobileMenuItems.forEach(item => {
      const toggle = item.querySelector('.mobile-menu-item__toggle');
      const submenu = item.querySelector('.mobile-menu-item__submenu');
      
      if (toggle) {
        toggle.addEventListener('click', () => {
          const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
          toggle.setAttribute('aria-expanded', !isExpanded);
          
          if (submenu) {
            submenu.classList.toggle('active');
          }
        });
      }
    });
  }

  // Initialize everything
  function setupEventListeners() {
    // Header height
    setHeaderHeight();
    window.addEventListener('resize', setHeaderHeight);
    
    // Set mobile logo width
    const logo = document.querySelector('.custom-header__logo');
    if (logo) {
      const mobileWidth = logo.dataset.mobileLogoWidth;
      if (mobileWidth) {
        document.documentElement.style.setProperty('--mobile-logo-width', `${mobileWidth}px`);
      }
    }
    
    // Setup nav hover effects
    setupNavHoverEffects();
    
    // Mobile menu
    if (elements.menuToggle && elements.mobileNav && elements.overlay) {
      elements.menuToggle.addEventListener('click', function() {
        if (elements.mobileNav.dataset.state === 'closed') {
          openMobileMenu();
        } else {
          closeMobileMenu();
        }
      });
      
      elements.overlay.addEventListener('click', closeMobileMenu);
      
      document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape' && elements.mobileNav.dataset.state === 'open') {
          closeMobileMenu();
        }
      });
    }
    
    // Mega menu
    if (elements.primaryMenu) {
      elements.megaMenuTriggers.forEach(trigger => {
        const panelId = trigger.dataset.megamenuTrigger;
        const panel = document.getElementById(panelId);
        
        trigger.addEventListener('mouseenter', () => showMegaMenu(panelId));
        trigger.addEventListener('mouseleave', () => hideMegaMenu(panel));
        
        if (panel) {
          panel.addEventListener('mouseenter', () => {
            if (hideTimeout) {
              clearTimeout(hideTimeout);
              hideTimeout = null;
            }
          });
          
          panel.addEventListener('mouseleave', () => hideMegaMenu(panel));
        }
      });
    }
    
    // Update counts
    updateCartCount();
    updateQuotesCount();
    
    document.addEventListener('cart:updated', updateCartCount);
    document.addEventListener('quotes:updated', updateQuotesCount);
    
    // Setup mobile menu
    setupMobileMenu();
  }

  // Initialize everything
  setupEventListeners();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const innerHTML = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('product-recommendations');
            if (innerHTML && innerHTML.querySelectorAll('.product-item').length > 0) {
              this.innerHTML = innerHTML.innerHTML;
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
